import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", {
          session_id: sessionId,
          ref_code: localStorage.getItem("gs_ref_code") || undefined,
          consent: localStorage.getItem("gs_legal_consent") === "1",
        });
        setUser(res.data);
        // Promo attribution: if this signup came from a promo card, record it by angle
        try {
          const angle = localStorage.getItem("aps_ref_angle");
          const platform = localStorage.getItem("aps_ref_platform");
          if (angle && res.data?.is_new) {
            api.post("/promo/track", { type: "signup", angle, platform }).catch(() => {});
          }
          localStorage.removeItem("aps_ref_angle");
          localStorage.removeItem("aps_ref_platform");
          localStorage.removeItem("gs_ref_code");
        } catch (e) {}
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
